/* eslint-disable no-console */
import { getPartnerAccessToken } from '@leagueplatform/sso-util';
import { format } from 'date-fns';
import {
  PHONE_NUMBER_TYPE,
  FORM_API_TYPE,
  STATE_VALUE,
} from '../../types/online-forms.types';

// import { FormInstriction } from '@en';

export const memberNameOption = (profileResponseData: any) => {
  const dependents = profileResponseData?.demographics?.dependents;
  const demographicsData = profileResponseData?.demographics;

  const dependentsUser = dependents?.map((option: any) => ({
    value: `${option.firstName} ${option.lastName}`,
    label: `${option.firstName} ${option.lastName}`,
  }));

  const mainUser = {
    value: `${demographicsData?.firstName} ${demographicsData?.lastName}`,
    label: `${demographicsData?.firstName} ${demographicsData?.lastName}`,
  };
  dependentsUser?.unshift(mainUser);
  return dependentsUser;
};

function modifyNumber(value: string) {
  if (!value) return value;
  const phoneNumberLength = value.length;
  let phNum: any = '';
  if (phoneNumberLength === 10) {
    phNum = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }
  return phNum;
}

export const phoneNumberOption = (profileResponseData: any) => {
  const contactPoints = profileResponseData?.demographics?.contactPoints;
  const filteredArray = contactPoints?.filter(
    (option: any) => option.type === PHONE_NUMBER_TYPE.PHONE,
  );

  const selectedNumber = filteredArray?.map((option: any) => ({
    value: modifyNumber(option.value),
    label: `${option.use} ${':'}  ${modifyNumber(option.value)}`,
  }));

  const otherPhoneNumber = {
    value: PHONE_NUMBER_TYPE.OTHERS,
    label: PHONE_NUMBER_TYPE.OTHERS,
  };
  selectedNumber?.push(otherPhoneNumber);
  return selectedNumber;
};

export function formatPhoneNumber(value: string) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

export function stateOption() {
  const state = STATE_VALUE?.map((option: any) => ({
    value: option,
    label: option,
  }));
  return state;
}

export function isEmpty(value: string) {
  return value == null || value.length === 0;
}

export function isNotEmpty(value: string) {
  if (!value) return value;
  return value.length > 0;
}

export function isValidatePhoneLength(val: string) {
  return val?.length >= 1 && val?.length < 14;
}

export async function getAccessToken(url: string) {
  const token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'GET',

    headers: new Headers({
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    }),
  };
  try {
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export async function postAccessToken(url: string, payload: any) {
  const token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  };
  try {
    // eslint-disable-next-line no-await-in-loop
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export function replaceSpecialCharacter(val: string) {
  return val.replace(/[^0-9]/g, '');
}

export async function submitForm(formName: string) {
  const userData = JSON.parse(sessionStorage.getItem('formData') || '{}');
  let userData1 = {};
  switch (formName) {
    case FORM_API_TYPE.MEDICATION_EXCEPTION:
      userData1 = {
        memberName: userData?.memberName,
        memberId: userData?.memberId,
        memberDob: format(new Date(userData?.dateOfBirth), 'MM/dd/yyyy'),
        memberPhoneNo:
          userData?.phoneNumber === PHONE_NUMBER_TYPE.OTHERS
            ? replaceSpecialCharacter(userData?.otherPhoneNumber)
            : replaceSpecialCharacter(userData?.phoneNumber),
        prescriberName: userData?.fullName,
        prescriberFaxNo: userData?.faxNumber,
        prescriberPhoneNo: replaceSpecialCharacter(
          userData?.prescriberPhoneNumber,
        ),
        addr1: userData?.addressLine1,
        city: userData?.city,
        state: userData?.state,
        zipCode: userData?.zipCode,
        medicationName: userData?.medicationName,
        reasonForMedication: userData?.reasonForMedication,
      };
      break;
    case FORM_API_TYPE.STEP_THERAPY:
      userData1 = {
        memberName: userData?.memberName,
        memberId: userData?.memberId,
        memberDob: format(new Date(userData?.dateOfBirth), 'MM/dd/yyyy'),
        memberPhoneNo:
          userData?.phoneNumber === PHONE_NUMBER_TYPE.OTHERS
            ? replaceSpecialCharacter(userData?.otherPhoneNumber)
            : replaceSpecialCharacter(userData?.phoneNumber),
        prescriberName: userData?.prescriberName,
        prescriberPhoneNo: replaceSpecialCharacter(
          userData?.prescriberPhoneNumber,
        ),
        drugName: userData?.drugName,
        strength: userData?.strength,
        quantity: userData?.quantity,
        reasonForRequest: userData?.explainYourRequest,
      };
      break;
    case FORM_API_TYPE.OTHER_INSURANCE:
      userData1 = {
        hasAdditionalInsurance: userData?.hasAdditionalInsurance,
      };
      break;
    default:
  }

  const token = await getPartnerAccessToken('highmark');
  const url = `https://api-dev.highmark.com/digital/v1/members/forms-library/${formName}/submit`;
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(userData1),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    console.log(data);
  } catch (error) {
    console.error(error);
  }
}

export function emptyStorage() {
  sessionStorage.removeItem('formData');
}

export function updateFormData(value: any) {
  const prevData = JSON.parse(sessionStorage.getItem('formData') || '{}');
  Object.keys(value).forEach((val) => {
    prevData[val] = value[val];
  });
  sessionStorage.setItem('formData', JSON.stringify(prevData));
}

export function capitalizeFirstLetter(text: string) {
  const firstChar = text[0].toUpperCase();
  const rest = text.toLowerCase().slice(1);
  return firstChar + rest;
}

export function isLeapYear(year: number) {
  return new Date(year, 1, 29).getDate() === 29;
}

// update this param name
export function isInvalidDate(date: string) {
  const splitDate = date.split('/'); // splitDate = [MM, DD, YYYY]
  const month = Number(splitDate[0]);
  const day = Number(splitDate[1]);
  const year = Number(splitDate[2]);

  if (month > 12 || month < 1) {
    return true;
  }
  if (month === 9 || month === 6 || month === 11 || month === 4) {
    if (day > 30 || day <= 0) {
      return true;
    }
  } else if (month === 2) {
    if (isLeapYear(year)) {
      if (day > 29 || day <= 0) {
        return true;
      }
    } else if (!isLeapYear(year)) {
      if (day > 28 || day <= 0) {
        return true;
      }
    }
  }
  if (day > 31 || day <= 0) {
    return true;
  }

  return false;
}
